import Home from './home'
import Download from '@/pages/download'
import VendorsList from '@/pages/vendors/list'
import VendorsSingle from '@/pages/vendors/single'
import OrdersList from '@/pages/orders/list'
import OrdersSingle from '@/pages/orders/single'
import PayoutsList from '@/pages/payouts/list'
import PayoutsSingle from '@/pages/payouts/single'
import AccountsList from '@/pages/accounts/list'
// import VendorPortalDashboard from '@/pages/vendorPortal/dashboard'
// import VendorPortalLogin from '@/pages/vendorPortal/login'
import ProductsList from '@/pages/products/list'
// import ProductsSingle from '@/pages/products/single'
// import CommissionProfilesList from '@/pages/commissionProfiles/list'
import SettingsGeneral from '@/pages/settings/general'
import termsService from '@/pages/legal/termsService'
import privacyPolicy from '@/pages/legal/privacyPolicy'

import helpRoutes from '@/pages/help/routes'

let routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/download',
    name: 'download',
    component: Download
  },
  {
    path: '/vendors',
    name: 'vendorsList',
    component: VendorsList
  },
  {
    path: '/vendors/:id',
    name: 'vendorsSingle',
    component: VendorsSingle
  },
  {
    path: '/orders',
    name: 'ordersList',
    component: OrdersList
  },
  {
    path: '/orders/:id',
    name: 'ordersSingle',
    component: OrdersSingle
  },
  {
    path: '/payouts',
    name: 'payoutsList',
    component: PayoutsList
  },
  {
    path: '/payouts/:id',
    name: 'payoutsSingle',
    component: PayoutsSingle
  },
  {
    path: '/accounts',
    name: 'AccountsList',
    component: AccountsList
  },
  {
    path: '/products',
    name: 'productsList',
    component: ProductsList
  },
  // {
  //   path: '/products/:id',
  //   name: 'productsSingle',
  //   component: ProductsSingle
  // },
  // {
  //   path: '/commission-profiles',
  //   name: 'commissionProfilesList',
  //   component: CommissionProfilesList
  // },
  {
    path: '/settings/',
    name: 'settingsGeneral',
    component: SettingsGeneral
  },
  {
    path: '/terms-of-service',
    name: 'termsService',
    component: termsService
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: privacyPolicy
  }
]

routes = routes.concat(helpRoutes)

export default routes



// WEBPACK FOOTER //
// ./src/apps/vendorconsignment/routes.js